var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9426 2.99805C21.4113 4.63867 21.4113 8.1543 21.4113 8.1543C21.4113 8.1543 21.4113 11.6309 20.9426 13.3105C20.7082 14.248 19.966 14.9512 19.0676 15.1855C17.3879 15.6152 10.7473 15.6152 10.7473 15.6152C10.7473 15.6152 4.06758 15.6152 2.38789 15.1855C1.48945 14.9512 0.747266 14.248 0.512891 13.3105C0.0441408 11.6309 0.0441408 8.1543 0.0441408 8.1543C0.0441408 8.1543 0.0441408 4.63867 0.512891 2.99805C0.747266 2.06055 1.48945 1.31836 2.38789 1.08398C4.06758 0.615234 10.7473 0.615234 10.7473 0.615234C10.7473 0.615234 17.3879 0.615234 19.0676 1.08398C19.966 1.31836 20.7082 2.06055 20.9426 2.99805ZM8.55977 11.3184L14.1066 8.1543L8.55977 4.99023V11.3184Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e4bd655283ce6bc61b8cf56384e2f81e.svg";
export { ForwardRef as ReactComponent };